// @flow
import { useCallback, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CompatibilityContext } from '../../../contexts/compatibility';
import AxiosInstanceFactory from '../../../utils/axiosInstance';
import { apiCompatibilityCheck } from '../../../app_routes/ringBuilder';
import { handleError } from '../../../utils/errors';

type TProps = {
  diamondId: ?number
};

export default function SettingCompatibility({ diamondId }: TProps) {
  const axiosInstance = AxiosInstanceFactory();
  const { compatibility, setCompatibility } = useContext(CompatibilityContext);
  const dispatch = useDispatch();
  const compatible = compatibility.compatible;
  const recommended = compatibility.recommended;
  const settingSku = useSelector(state => state.ringBuilder.setting.sku);

  const handleClick = useCallback(() => {
    dispatch({ type: 'CLEAR_DYOR_SETTING' });
  }, []);

  useEffect(() => {
    if (settingSku && diamondId) {
      const updateCompatibility = async () => {
        const res = await axiosInstance.post(apiCompatibilityCheck, {
          setting_sku: settingSku,
          diamond_id: diamondId
        });

        setCompatibility(res.data);
      };

      updateCompatibility().catch(handleError);
    } else {
      setCompatibility({ compatible: true });
    }
  }, [settingSku, diamondId]);

  if (compatible) return null;
  // Since there is a setting that will fit, we will set that as the selected
  // setting when the user adds this diamond to the dyor.
  if (recommended) return null;

  // Since the setting/diamond are not compatible and there is not a comparable
  // setting that is compatible, we tell the user that they can't add this
  // diamond unless they remove the setting first.
  return (
    <div className='flash-message alert'>
      This diamond is not compatible with your chosen setting. Please{' '}
      <a href='javascript:void(0)' onClick={handleClick}>
        delete
      </a>{' '}
      your setting if you wish to choose this diamond.
    </div>
  );
}
